<div class="messaggio-pagina">
  <mat-icon class="messaggio-pagina__segno" aria-hidden="true">lock</mat-icon>
  <h1>Non hai i permessi per questa pagina</h1>
  <p>Se pensi che sia un errore, chiedi a chi amministra il pannello di controllare il tuo ruolo.</p>
  <div class="messaggio-pagina__azioni">
    <button type="button" mat-stroked-button (click)="goHome()">Torna alla dashboard</button>
    <button type="button" mat-flat-button color="primary" (click)="authService.login()">Accedi</button>
  </div>
</div>
